import isEmpty from "lodash/isEmpty";

export default {
    getMoyenCommerciaux: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            !isEmpty(rootState.user.bpi.moyen_commerciaux)
        ) {
            const moyenCommerciauxProfiles =
                rootState.user.bpi.moyen_commerciaux;

            return {
                ...moyenCommerciauxProfiles
            };
        }

        return {
            strategiePrix: null,
            strategieProduction: null,
            choix1: null,
            choix2: null,
            objectifsCommunication: [],
            cannauxComunication: [],
            budgetCommunication: null
        };
    }
};
